import { render } from "./FrontPageMenu.vue?vue&type=template&id=c44a0f0a&scoped=true"
import script from "./FrontPageMenu.vue?vue&type=script&lang=js"
export * from "./FrontPageMenu.vue?vue&type=script&lang=js"

import "./FrontPageMenu.vue?vue&type=style&index=0&id=c44a0f0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c44a0f0a"]])

export default __exports__